import { MetaDescriptor } from "react-router";

export const schemaOrg = {
  organization: {
    "@type": "Organization",
    "name": "CountLike.PRO",
    "description": "An online toolbox with a variety of calculators and converters for various needs",
    "url": "https://countlike.pro",
    "logo": "https://countlike.pro/favicon.svg",
  },
  authorAlexFedorov: {
    "@type": "Person",
    "name": "Alex Fedorov",
    "image": "https://static.countlike.pro/Alex-Fedorov.webp",
  }
};

/**
 * https://schema.org/WebApplication
 */
export function createWebAppSchema(
  locale: string,
  title: string,
  images: string[],
  dateModified: Date|null = null,
  author: object = schemaOrg.organization,
): MetaDescriptor {
  return {
    "script:ld+json": {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": title,
      "applicationCategory": "UtilityApplication",
      "image": images.length > 0 ? images : [schemaOrg.organization.logo],
      "inLanguage": locale,
      "author": [author],
      "dateModified": dateModified ? dateModified.toISOString() : undefined
    }
  };
}

/**
 * https://developers.google.com/search/docs/appearance/structured-data/faqpage
 */
export function createFAQSchema(faqs: Array<{ q: string; a: string }>): MetaDescriptor | null {
  if (faqs.length === 0) return null;
  return {
    "script:ld+json": {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map(({ q, a }) => ({
        "@type": "Question",
        "name": q,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": a
        }
      }))
    }
  };
}

/**
 * https://developers.google.com/search/docs/appearance/structured-data/article?hl=ru
 */
export function createArticleSchema(
  locale: string,
  title: string,
  images: string[],
  dateModified: Date|null = null,
  author: object = schemaOrg.organization,
): MetaDescriptor {
  return  {
    "script:ld+json": {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": title,
      "image": images,
      "inLanguage": locale,
      "author": [author],
      "dateModified": dateModified ? dateModified.toISOString() : undefined
    }
  };
}